"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4140],{

/***/ 22115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Table_DealTable; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(10528);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/UI/Pill.tsx
var Pill = __webpack_require__(50850);
// EXTERNAL MODULE: ./components/UI/buttons/Button.tsx + 3 modules
var Button = __webpack_require__(21489);
// EXTERNAL MODULE: ./components/cards/Avatar.tsx + 2 modules
var Avatar = __webpack_require__(89646);
// EXTERNAL MODULE: ./components/cards/AvatarInfo.tsx
var AvatarInfo = __webpack_require__(10934);
// EXTERNAL MODULE: ./hooks/useNftMeta.ts
var useNftMeta = __webpack_require__(77253);
// EXTERNAL MODULE: ./hooks/useWindowSize.tsx + 1 modules
var useWindowSize = __webpack_require__(8137);
;// CONCATENATED MODULE: ./components/cards/BidAvatarGroup.tsx





var BidAvatarGroup = function(param) {
    var data = param.data;
    var zStack = [
        "z-30",
        "z-20",
        "z-10"
    ];
    var windowSize = (0,useWindowSize/* default */.Z)();
    var ref = (0,react.useState)(2), avatarGroupCount = ref[0], setAvatarGroupCount = ref[1];
    (0,react.useEffect)(function() {
        setAvatarGroupCount(windowSize.width < 640 ? 2 : 3);
    }, [
        windowSize.width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-10 flex -space-x-4",
        children: [
            data.slice(0, avatarGroupCount).map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: zStack[index],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NftAvatar, {
                        data: item
                    })
                }, index);
            }),
            data.length > avatarGroupCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-0 bg-clip-border",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-[38px] w-[38px] place-content-center items-center rounded-lg bg-white pl-4 text-md text-primary-main md:h-[56px] md:w-[56px] md:pl-0 lg:text-lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "+",
                            data.length - avatarGroupCount
                        ]
                    })
                })
            }) : undefined
        ]
    });
};
/* harmony default export */ var cards_BidAvatarGroup = (BidAvatarGroup);
var NftAvatar = function(param) {
    var data = param.data;
    var nftImage = (0,useNftMeta/* default */.Z)({
        collectionAddress: data.Collection.nft_contract_address,
        tokenId: data.token_id
    }).nftImage;
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.ZP, {
        shape: Avatar/* AvatarShape.square */.oG.square,
        size: Avatar/* AvatarSize.sm */.DZ.sm,
        alt: (_alt = data.alt) !== null && _alt !== void 0 ? _alt : "avatar",
        src: nftImage
    });
};

// EXTERNAL MODULE: ./components/display/BudgetPerAsset.tsx + 2 modules
var BudgetPerAsset = __webpack_require__(98781);
// EXTERNAL MODULE: ./constants/constants.ts
var constants = __webpack_require__(36630);
// EXTERNAL MODULE: ./utilities/createBucketUrl.ts
var createBucketUrl = __webpack_require__(37785);
// EXTERNAL MODULE: ./utilities/dateFormatter.ts
var dateFormatter = __webpack_require__(17695);
;// CONCATENATED MODULE: ./components/Table/BidTableRow.tsx














var BidTableRow = function(param) {
    var deal = param.deal;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var bidTotal;
    if (deal === null || deal === void 0 ? void 0 : (ref = deal.Deal) === null || ref === void 0 ? void 0 : (ref1 = ref.Bids) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Bids_private_info) === null || ref3 === void 0 ? void 0 : ref3.bid_amount) {
        bidTotal = deal.Deal.Bids.reduce(function(state, next) {
            var ref;
            return state.add(bignumber/* BigNumber.from */.O$.from((next === null || next === void 0 ? void 0 : (ref = next.Bids_private_info) === null || ref === void 0 ? void 0 : ref.bid_amount) || 0));
        }, bignumber/* BigNumber.from */.O$.from(0));
    } else {
        bidTotal = null;
    }
    var localBiddingExpDate = (0,dateFormatter/* getLocalDate */.ZF)(deal.Deal.bidding_expiration, constants/* DATE_FORMATS.MMMDYhm */.lv.MMMDYhm);
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,dateFormatter/* getHumanizedDate */.n$)(localBiddingExpDate), 2), humanizedLocalBiddingExpDate = ref17[0], dateEnum = ref17[1];
    var _dateEnum = dateFormatter/* DateThemeMap */.xj[dateEnum], theme = _dateEnum.theme, pulse = _dateEnum.pulse;
    var ref18, ref19;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/deal/".concat(deal.Deal.id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid w-full grid-cols-9 rounded-lg px-0 py-4 hover:cursor-pointer md:grid-cols-12 md:px-4 md:hover:bg-primary-surface",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-4 cursor-pointer md:col-span-6 lg:col-span-4",
                    children: deal.Deal.Brand && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarInfo/* default */.Z, {
                        size: Avatar/* AvatarSize.sm */.DZ.sm,
                        imageLink: deal.Deal.Brand.username ? "/brand/".concat(encodeURI(deal.Deal.Brand.username), " ") : "",
                        textLink: "/deal/".concat(deal.id),
                        image: deal.Deal.Brand.username ? (0,createBucketUrl/* createBucketURL */.C)(createBucketUrl/* BucketType.Brand */.a.Brand, deal.Deal.Brand.username, deal.Deal.Brand.updated_at) : "",
                        verified: false,
                        alt: deal.Deal.Brand.company_name ? "".concat(deal.Deal.Brand.company_name, " brand icon") : "brand icon",
                        title: deal.Deal.title,
                        primaryInfo: "".concat((ref18 = (ref6 = (ref4 = deal.Deal.Brand) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.company_name) === null || ref5 === void 0 ? void 0 : ref5.charAt(0)) === null || ref6 === void 0 ? void 0 : ref6.toUpperCase()) !== null && ref18 !== void 0 ? ref18 : "").concat((ref19 = (ref7 = deal.Deal.Brand) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.company_name) === null || ref8 === void 0 ? void 0 : ref8.slice(1)) !== null && ref19 !== void 0 ? ref19 : "")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " col-span-4 flex justify-end md:col-span-5 md:justify-start lg:col-span-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_BidAvatarGroup, {
                        size: Avatar/* AvatarSize.sm */.DZ.sm,
                        data: deal.Deal.Bids
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden self-center text-left text-black md:col-span-2 lg:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetPerAsset/* BudgetPerAsset */.E, {
                        paymentCurrency: deal.Deal.payment_currency,
                        minBudget: bidTotal ? bidTotal.toString() : undefined,
                        royaltyPercentage: deal === null || deal === void 0 ? void 0 : (ref9 = deal.Deal) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Bids) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Bids_private_info) === null || ref12 === void 0 ? void 0 : ref12.bid_percentage_amount,
                        displayMode: BudgetPerAsset/* BudgetDisplayMode.WITHOUT_TITLE */.A.WITHOUT_TITLE,
                        classes: "mx-2"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "justify-content-left hidden self-center text-left text-black md:col-span-2 lg:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.ZP, {
                        theme: theme,
                        showDot: true,
                        pulse: pulse,
                        title: localBiddingExpDate,
                        children: humanizedLocalBiddingExpDate
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 hidden h-10 w-10 self-center rounded-full bg-white md:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/api/pdf/".concat(deal === null || deal === void 0 ? void 0 : (ref13 = deal.Deal) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Bids) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Bids_private_info) === null || ref16 === void 0 ? void 0 : ref16.agreementHash),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            classes: "inline-flex items-center justify-center text-xs leading-none",
                            type: Button/* ButtonType.primary */.L$.primary,
                            size: Button/* ButtonSize.sm */.qE.sm,
                            children: "Download Agreement"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Table_BidTableRow = (BidTableRow);

// EXTERNAL MODULE: ./components/cards/AvatarGroup.tsx
var AvatarGroup = __webpack_require__(91469);
// EXTERNAL MODULE: ./components/navigation/ArrowButton.tsx + 1 modules
var ArrowButton = __webpack_require__(56245);
// EXTERNAL MODULE: ./utilities/functions.ts + 5 modules
var functions = __webpack_require__(12477);
;// CONCATENATED MODULE: ./components/Table/DealTableRow.tsx














var DealTableRow = function(param) {
    var deal = param.deal;
    var ref, ref1, ref2;
    var localBiddingExpDate = (0,dateFormatter/* getLocalDate */.ZF)(deal.bidding_expiration, constants/* DATE_FORMATS.MMMDYhm */.lv.MMMDYhm);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,dateFormatter/* getHumanizedDate */.n$)(localBiddingExpDate), 2), humanizedLocalBiddingExpDate = ref3[0], dateEnum = ref3[1];
    var _dateEnum = dateFormatter/* DateThemeMap */.xj[dateEnum], theme = _dateEnum.theme, pulse = _dateEnum.pulse;
    var _username, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/deal/".concat(deal.id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid w-full grid-cols-8 rounded-lg px-0 py-4 hover:cursor-pointer md:grid-cols-12 md:px-4 md:hover:bg-primary-surface",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-4 cursor-pointer md:col-span-6 lg:col-span-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarInfo/* default */.Z, {
                        size: Avatar/* AvatarSize.sm */.DZ.sm,
                        address: deal.Brand.wallet_address ? (0,functions/* cleanAddress */.Wm)(deal.Brand.wallet_address) : "",
                        imageLink: "/brand/".concat(encodeURI((_username = deal.Brand.username) !== null && _username !== void 0 ? _username : "")),
                        textLink: "/deal/".concat(deal.id),
                        image: deal.Brand.username ? (0,createBucketUrl/* createBucketURL */.C)(createBucketUrl/* BucketType.Brand */.a.Brand, deal.Brand.username, deal.Brand.updated_at) : "",
                        verified: false,
                        contentClasses: "text-sm",
                        alt: deal.Brand.company_name ? "".concat(deal.Brand.company_name, " brand icon") : "brand icon",
                        title: deal.title,
                        primaryInfo: (ref4 = ((ref = deal.Brand) === null || ref === void 0 ? void 0 : ref.company_name) && "".concat((ref1 = deal.Brand) === null || ref1 === void 0 ? void 0 : ref1.company_name.charAt(0).toUpperCase()).concat((ref2 = deal.Brand) === null || ref2 === void 0 ? void 0 : ref2.company_name.slice(1))) !== null && ref4 !== void 0 ? ref4 : ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-4 flex justify-end md:col-span-5 md:justify-start lg:col-span-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarGroup/* default */.Z, {
                        size: Avatar/* AvatarSize.sm */.DZ.sm,
                        data: (0,AvatarGroup/* convertDealsToAvatarItems */.d)(deal.CollectionDeals),
                        linkTemplate: "/collection/{0}"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "start hidden self-center pr-3 text-left text-black md:col-span-2 lg:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetPerAsset/* BudgetPerAsset */.E, {
                        paymentCurrency: deal.payment_currency,
                        minBudget: deal.min_budget,
                        maxBudget: deal.max_budget,
                        royaltyPercentage: deal.royalty_percentage,
                        displayMode: BudgetPerAsset/* BudgetDisplayMode.WITHOUT_TITLE */.A.WITHOUT_TITLE,
                        classes: "mx-2"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "start hidden self-center md:col-span-2 lg:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.ZP, {
                        theme: theme,
                        showDot: true,
                        pulse: pulse,
                        title: localBiddingExpDate,
                        classes: "mt-0",
                        children: humanizedLocalBiddingExpDate
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-1 hidden h-10 w-10 self-center justify-self-end rounded-full bg-white md:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowButton/* default */.ZP, {
                        direction: ArrowButton/* ArrowDirection.right */.n4.right,
                        classes: "text-primary-main"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Table_DealTableRow = (DealTableRow);

// EXTERNAL MODULE: ./components/cards/EmptyBidCard.tsx
var EmptyBidCard = __webpack_require__(49141);
// EXTERNAL MODULE: ./components/layout/LoadingView.tsx + 1 modules
var LoadingView = __webpack_require__(5431);
;// CONCATENATED MODULE: ./components/Table/DealTable.tsx






var DealTable = function(param) {
    var deals = param.deals, _heading = param.heading, heading = _heading === void 0 ? "All Opportunities" : _heading, bids = param.bids, _authed = param.authed, authed = _authed === void 0 ? false : _authed, emptyHasButton = param.emptyHasButton, emptyButtonPath = param.emptyButtonPath, emptyButtonText = param.emptyButtonText, emptyCardText = param.emptyCardText, _filters = param.filters, filters = _filters === void 0 ? null : _filters, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto flex w-full flex-col text-center",
        children: [
            deals && heading !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto flex h-full w-full flex-col justify-between gap-4 pb-4 md:flex-row md:items-center md:gap-2 md:pb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-0 py-0 text-left font-gt-haptik text-heading-5-mobile font-bold text-black md:px-3 md:text-heading-5",
                        children: heading
                    }),
                    filters
                ]
            }),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingView/* default */.Z, {}) : (deals === null || deals === void 0 ? void 0 : deals.length) || (bids === null || bids === void 0 ? void 0 : bids.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid w-full grid-cols-8 px-0 pb-4 text-neutral-50 md:grid-cols-12 md:px-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-grey text-xs ".concat(deals ? "col-span-4 md:col-span-6 lg:col-span-4" : "col-span-4 md:col-span-6 lg:col-span-4", " text-left md:text-sm"),
                                children: "Opportunity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-grey text-xs col-span-4 text-right md:col-span-5 lg:col-span-3 ".concat(deals ? "" : "", " md:text-left md:text-sm"),
                                children: deals ? "Eligible Collections" : "Proposed"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-grey text-xs col-span-2 hidden justify-start px-0 text-left ".concat(deals ? "lg:flex" : "lg:flex", " md:text-sm"),
                                children: deals ? "Est. Budget Per Asset" : authed ? "Proposed Amount" : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-grey text-xs col-span-2 hidden justify-start text-left md:text-sm lg:flex ",
                                children: "Submission Deadline"
                            })
                        ]
                    }),
                    deals && deals.map(function(deal) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_DealTableRow, {
                            deal: deal
                        }, deal.id);
                    }),
                    bids && bids.map(function(bid) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_BidTableRow, {
                            deal: bid
                        }, bid.id);
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyBidCard/* EmptyBidCard */.P, {
                hasButton: emptyHasButton,
                buttonPath: emptyButtonPath,
                buttonText: emptyButtonText,
                title: emptyCardText
            })
        ]
    });
};
/* harmony default export */ var Table_DealTable = (DealTable);


/***/ }),

/***/ 91469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ convertDealsToAvatarItems; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_cards_Avatar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89646);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36630);
/* harmony import */ var _hooks_useNftMeta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77253);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8137);
/* harmony import */ var _utilities_createBucketUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37785);
/* harmony import */ var _utilities_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12477);
/* harmony import */ var _utilities_tailwind__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88651);










var AvatarDisplay = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var item = param.item, size = param.size, linkTemplate = param.linkTemplate, showBorder = param.showBorder, showCount = param.showCount;
    var isCollection = !item.token_id;
    var cleanedAddress = (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_7__/* .cleanAddress */ .Wm)(item.nft_contract_address);
    var nftMeta = (0,_hooks_useNftMeta__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        collectionAddress: isCollection ? null : item.nft_contract_address,
        tokenId: isCollection ? null : item.token_id,
        network: isCollection ? null : (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_7__/* .getAlchemyNetwork */ .Op)(_constants_constants__WEBPACK_IMPORTED_MODULE_3__/* .CHAIN_ID */ .Kj)
    });
    var nftThumbnail = !isCollection ? nftMeta === null || nftMeta === void 0 ? void 0 : nftMeta.nftThumbnail : null;
    var src = isCollection ? (0,_utilities_createBucketUrl__WEBPACK_IMPORTED_MODULE_6__/* .createBucketURL */ .C)(_utilities_createBucketUrl__WEBPACK_IMPORTED_MODULE_6__/* .BucketType.Collection */ .a.Collection, cleanedAddress) : nftThumbnail;
    var link = cleanedAddress ? linkTemplate === null || linkTemplate === void 0 ? void 0 : linkTemplate.replace("{0}", cleanedAddress) : undefined;
    var _alt;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Tooltip */ .u, {
            label: item.alt,
            color: (0,_utilities_tailwind__WEBPACK_IMPORTED_MODULE_8__/* .getTailwindColor */ .c)("primary").hover,
            transitionProps: {
                transition: "slide-up",
                duration: 300
            },
            openDelay: 100,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pointer-events-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cards_Avatar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    shape: _components_cards_Avatar__WEBPACK_IMPORTED_MODULE_2__/* .AvatarShape.square */ .oG.square,
                    size: size,
                    address: cleanedAddress,
                    alt: (_alt = item.alt) !== null && _alt !== void 0 ? _alt : "avatar",
                    src: src,
                    link: link,
                    showBorder: showBorder,
                    count: showCount !== false ? item.count : undefined
                })
            })
        })
    });
});
AvatarDisplay.displayName = "AvatarDisplay";
var AvatarGroup = function(param) {
    var data = param.data, size = param.size, linkTemplate = param.linkTemplate, showBorder = param.showBorder, showCount = param.showCount;
    var zStack = [
        "z-30",
        "z-20",
        "z-10"
    ];
    var windowSize = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(2), avatarGroupCount = ref[0], setAvatarGroupCount = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setAvatarGroupCount(windowSize.width < 640 ? 2 : 3);
    }, [
        windowSize.width
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "z-10 flex -space-x-4",
            children: [
                data.slice(0, avatarGroupCount).map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: zStack[index],
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarDisplay, {
                            item: item,
                            size: size,
                            linkTemplate: linkTemplate,
                            showBorder: showBorder,
                            showCount: showCount
                        })
                    }, index);
                }),
                data.length > avatarGroupCount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative z-0 bg-clip-border",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex h-[38px] w-[38px] place-content-center items-center rounded-lg bg-white pl-4 text-md text-primary-main md:h-[56px] md:w-[56px] md:pl-0 lg:text-lg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                "+",
                                data.length - avatarGroupCount
                            ]
                        })
                    })
                }) : undefined
            ]
        })
    });
};
var convertDealsToAvatarItems = function(collectionDeals) {
    return collectionDeals.map(function(deal) {
        var ref, ref1;
        var ref2;
        var nftAddress = (ref2 = (ref = deal.Collection) === null || ref === void 0 ? void 0 : ref.nft_contract_address) !== null && ref2 !== void 0 ? ref2 : "";
        var altName = (ref1 = deal.Collection) === null || ref1 === void 0 ? void 0 : ref1.name;
        var _count;
        return {
            nft_contract_address: nftAddress,
            alt: altName,
            count: (_count = deal.count) !== null && _count !== void 0 ? _count : 0
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvatarGroup);


/***/ }),

/***/ 49141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EmptyBidCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_icons_tb___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58920);
/* harmony import */ var _components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21489);





var EmptyBidCard = function(param) {
    var title = param.title, _hasButton = param.hasButton, hasButton = _hasButton === void 0 ? false : _hasButton, _buttonPath = param.buttonPath, buttonPath = _buttonPath === void 0 ? "/deals" : _buttonPath, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "View Opportunities" : _buttonText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex w-full flex-col place-content-center place-items-center py-8 text-black",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb___WEBPACK_IMPORTED_MODULE_4__/* .TbIdOff */ .T_6, {
                className: "text-heading-3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-1/2 justify-center p-4 text-center font-gt-haptik text-heading-6-mobile md:text-heading-6",
                children: title
            }),
            hasButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                className: "flex items-center py-2",
                href: buttonPath,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    size: _components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonSize.primary */ .qE.primary,
                    type: _components_UI_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonType.primary */ .L$.primary,
                    children: buttonText
                })
            }) : null
        ]
    });
};


/***/ }),

/***/ 637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var SeoHead = function(param) {
    var title = param.title, description = param.description, imageURI = param.imageURI, pagePath = param.pagePath, twitterTitle = param.twitterTitle, twitterDescription = param.twitterDescription;
    var defaultDescription = description !== null && description !== void 0 ? description : "Most people don’t have the resources, time, or connections to truly use their web3 IP. Our goal at OverpassIP is to provide holders with easily accessible opportunities to leverage their NFTs IP. With OverpassIP, the web3 user will seamlessly connect with the Web2 brand. Join us in revolutionizing IP functionality for years to come.";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                type: "image/svg+xml",
                href: "/overpass.svg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: defaultDescription
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pagePath !== null && pagePath !== void 0 ? pagePath : "/"
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: "@OverpassIP"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twitterTitle ? twitterTitle : title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twitterDescription ? twitterDescription : defaultDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageURI ? imageURI : "/img/OverPassCover.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 56245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kJ": function() { return /* binding */ ArrowButtonStyle; },
  "n4": function() { return /* binding */ ArrowDirection; },
  "ZP": function() { return /* binding */ navigation_ArrowButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/svg/LeftNavArrow.tsx


var LeftNavArrow = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8490FF" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1344_798)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19 12L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11 6L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11 18L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1344_798",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(24 24) rotate(-180)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var svg_LeftNavArrow = (LeftNavArrow);

;// CONCATENATED MODULE: ./components/navigation/ArrowButton.tsx



var ArrowDirection;
(function(ArrowDirection) {
    ArrowDirection["left"] = "rotate-0";
    ArrowDirection["right"] = "rotate-180";
    ArrowDirection["up"] = "rotate-90";
    ArrowDirection["down"] = "-rotate-90";
})(ArrowDirection || (ArrowDirection = {}));
var ArrowButtonStyle;
(function(ArrowButtonStyle) {
    ArrowButtonStyle["default"] = "flex rounded-full w-10 h-10 bg-white active:bg-primary-pressed";
    ArrowButtonStyle["dark"] = "flex rounded-full w-10 h-10 font-white bg-primary-main active:bg-primary-pressed";
    ArrowButtonStyle["border"] = "flex rounded-full w-10 h-10 border-primary-main border-[1px] bg-white";
})(ArrowButtonStyle || (ArrowButtonStyle = {}));
var ArrowButton = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var _direction = param.direction, direction = _direction === void 0 ? ArrowDirection.left : _direction, classes = param.classes, _style = param.style, style = _style === void 0 ? ArrowButtonStyle.default : _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        ref: ref,
        className: "".concat(style, " flex-shrink-0"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full place-content-center items-center self-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: direction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_LeftNavArrow, {
                    classes: classes,
                    fill: style === ArrowButtonStyle.dark ? "#fff" : "#8490FF"
                })
            })
        })
    });
});
ArrowButton.displayName = "ArrowButton";
/* harmony default export */ var navigation_ArrowButton = (ArrowButton);


/***/ })

}]);